import { createAction } from 'redux-actions';
import * as types from './actionTypes';

export const announcementsRequest = createAction(types.ANNOUNCEMENTS_REQUEST);
export const announcementsSuccess = createAction(types.ANNOUNCEMENTS_SUCCESS);
export const announcementsFailure = createAction(types.ANNOUNCEMENTS_FAILURE);

export const announcementRequest = createAction(types.ANNOUNCEMENT_REQUEST);
export const announcementSuccess = createAction(types.ANNOUNCEMENT_SUCCESS);
export const announcementFailure = createAction(types.ANNOUNCEMENT_FAILURE);

export const createAnnouncementRequest = createAction(
  types.CREATE_ANNOUNCEMENT_REQUEST,
);
export const createAnnouncementSuccess = createAction(
  types.CREATE_ANNOUNCEMENT_SUCCESS,
);
export const createAnnouncementFailure = createAction(
  types.CREATE_ANNOUNCEMENT_FAILURE,
);

export const updateAnnouncementRequest = createAction(
  types.UPDATE_ANNOUNCEMENT_REQUEST,
);
export const updateAnnouncementSuccess = createAction(
  types.UPDATE_ANNOUNCEMENT_SUCCESS,
);
export const updateAnnouncementFailure = createAction(
  types.UPDATE_ANNOUNCEMENT_FAILURE,
);

export const deleteAnnouncementRequest = createAction(
  types.DELETE_ANNOUNCEMENT_REQUEST,
);
export const deleteAnnouncementSuccess = createAction(
  types.DELETE_ANNOUNCEMENT_SUCCESS,
);
export const deleteAnnouncementFailure = createAction(
  types.DELETE_ANNOUNCEMENT_FAILURE,
);

export const resetAnnouncement = createAction(types.RESET_ANNOUNCEMENT);

export default {
  resetAnnouncement,
  announcementsRequest,
  announcementsSuccess,
  announcementsFailure,
  announcementRequest,
  announcementSuccess,
  announcementFailure,
  createAnnouncementRequest,
  createAnnouncementSuccess,
  createAnnouncementFailure,
  updateAnnouncementRequest,
  updateAnnouncementSuccess,
  updateAnnouncementFailure,
  deleteAnnouncementRequest,
  deleteAnnouncementSuccess,
  deleteAnnouncementFailure,
};
